import { render, staticRenderFns } from "./StaticRegisterMultiSelect.vue?vue&type=template&id=2234257f"
import script from "./StaticRegisterMultiSelect.vue?vue&type=script&lang=js"
export * from "./StaticRegisterMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports